module.exports = __webpack_public_path__ + "img/06.f3fb9df6.jpg";